export enum MenuLabel {
  ManageAgents = 'Manage Agents',
  Conversations = 'Conversations',
  KnowledgeManagement = 'Knowledge Management',
  CallManagement = 'Call Management',
  BatchCalls = 'Mass Outreach (Demo)',
  WidgetAnalytics = 'Widget Analytics',
  RoleManagement = 'Role Management',
  OrgManagement = 'Org Management',
  JSONManagement = 'JSON Management',
  ModelsManagement = 'Model Management',
  ConversationsBilling = 'Billing',
  PromptLibrary = 'Prompt Library',
  SipTrunk = 'SIP Trunk',
  Logout = 'Logout',
  Login = 'Login',
  Analytics = 'Analytics',
}

export const bottomMenuLabels: string[] = [
  MenuLabel.Logout,
  MenuLabel.JSONManagement,
  MenuLabel.RoleManagement,
  MenuLabel.OrgManagement,
  MenuLabel.ModelsManagement,
  MenuLabel.PromptLibrary,
];
